import { HttpService } from "./https.service";
import { BASE_URL } from "../../config/config";
import {
  GetUploadedURL,
  DeleteUploadURL,
  AddUploadURL,
  UpdateUploadURL,
  ResponseType,
  AnalyticsBrand
} from "custom-type";

const http = new HttpService();

export class AnalyticsService {
  async getUploadedUrl(data: GetUploadedURL): Promise<ResponseType> {
    const path = BASE_URL + "/get/uploaded/url";
    try {
      const response = await http.postRequest(path, data, null);
      return response;
    } catch (error) {
      throw new Error(`Create Plan Service :: ${error}`);
    }
  }

  async deleteUploadURL(data: DeleteUploadURL): Promise<ResponseType> {
    const path = BASE_URL + "/delete/uploaded/url";
    try {
      const response = await http.postRequest(path, data, null);
      return response;
    } catch (error) {
      throw new Error(`Create Plan Service :: ${error}`);
    }
  }

  async addUploadURL(data: AddUploadURL): Promise<ResponseType> {
    const path = BASE_URL + "/add/uploaded/url";
    try {
      const response = await http.postRequest(path, data, null);
      return response;
    } catch (error) {
      throw new Error(`Create Plan Service :: ${error}`);
    }
  }

  async updateUploadURL(data: UpdateUploadURL): Promise<ResponseType> {
    const path = BASE_URL + "/update/uploaded/url";
    try {
      const response = await http.postRequest(path, data, null);
      return response;
    } catch (error) {
      throw new Error(`Create Plan Service :: ${error}`);
    }
  }

  async brandAnalytics(data: any): Promise<AnalyticsBrand> {
    const path = BASE_URL + "/get/brand/analytics";
    try {
      const response = await http.postRequest(path, data, null);
      return response;
    } catch (error) {
      throw new Error(`Create Plan Service :: ${error}`);
    }
  }
  async shareBrandAnalytics(data: any): Promise<AnalyticsBrand> {
    const path = BASE_URL + "/get/share-analytics";
    try {
      const response = await http.postRequest(path, data, null);
      return response;
    } catch (error) {
      throw new Error(`Create Plan Service :: ${error}`);
    }
  }
  async shareBrandAnalyticsYoutube(data: any): Promise<AnalyticsBrand> {
    const path = BASE_URL + "/get/share-analytics-yt";
    try {
      const response = await http.postRequest(path, data, null);
      return response;
    } catch (error) {
      throw new Error(`Create Plan Service :: ${error}`);
    }
  }

  async brandAnalyticsYoutube(data: any): Promise<AnalyticsBrand> {
    const path = BASE_URL + "/get/brand/analytics-yt";
    try {
      const response = await http.postRequest(path, data, null);
      return response;
    } catch (error) {
      throw new Error(`Create Plan Service :: ${error}`);
    }
  }

  async getAnalyticsLinks(campaignId: any) {
    const path = BASE_URL + `/analytics/postlinks/details?campaign_id=${campaignId}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Get getAnalyticsLinks Error :: ${error}`);
    }
  }

  async analyticsRefreshInight(data: any) {
    const path = BASE_URL + '/analytics/update/insights';
    try {
      const response = await http.postRequest(path, data, null);
      return response;
    } catch (error) {
      throw new Error(`analyticsRefreshInight :: ${error}`);
    }
  }
  async analyticsShareLinks(data: any) {
    const path = BASE_URL + '/analytics/share/details';
    try {
      const response = await http.postRequest(path, data, null);
      return response;
    } catch (error) {
      throw new Error(`analyticsShareLinks :: ${error}`);
    }
  }
  async analyticsSharedList(data: any) {
    const path = BASE_URL + `/analytics/share/list?campaign_id=${data.campaign_id}&plan_id=${data.planID}`;
    try {
      const response = await http.getRequest(path, null);

      return response;
    } catch (error) {
      throw new Error(`analyticsSharedList :: ${error}`);
    }
  }
  async checkEmailExists(payload: any) {
    const path = BASE_URL + `/analytics/check-email?campaign_id=${payload.campaign_id}&email=${payload.email}`
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`analyticsSharedList :: ${error}`);
    }
  }

  async deleteSharedUser(payload: any) {
    const path = BASE_URL + `/analytics/share/delete`;
    try {
      const response = await http.postRequest(path, payload, null);
      return response;
    } catch (error) {
      throw new Error(`analyticsSharedDeleteUser :: ${error}`);
    }
  }

  async analyticsDeleteUrl(data: any) {
    const path = BASE_URL + '/analytics/delete/url';
    try {
      const response = await http.postRequest(path, data, null);
      return response;
    } catch (error) {
      throw new Error(`analyticsDeleteUrl :: ${error}`);
    }
  }
  async verifySharedUser(payload: any) {
    const path = `${BASE_URL}/analytics/share/verify-token?campaignToken=${payload.campaignToken}&platform=${payload.campaignPlatform}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in verifySharedUser:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`verifySharedUser :: ${error}`);
    }
  }

  async verifySharedUserBrandPulse(payload: any) {
    const path = `${BASE_URL}/analytics/share-brand-pulse/verify-token?token=${payload.token}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in verifySharedUserBrandPulse:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`verifySharedUserBrandPulse :: ${error}`);
    }
  }

  async analyticsSharePublicLink(payload: any) {
    const path = `${BASE_URL}/get/share-link?campaignID=${payload.campaign_id}&platform=${payload.campaignPlatform}`;
    try {
      const response = await http.postRequest(path, payload, null);
      return response;
    } catch (error) {
      console.error("Error in verifySharedUser:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`verifySharedUser :: ${error}`);
    }
  }

  /**
   * Brand Pulse :: create the tracking campaign for a brand-pulse brand.
   * Backend inserts brd_campaigns (campaign_type 'Brand Pulse', visibility Private;
   * until Oct 2026 brand_plans + legacy brand_campaigns 'brand_pulse')
   * -> MYSQL_DB_NAME_2.lnk_campaignid_refid, and it is the link
   * row that makes the Campaign Tracking tab light up for this ref_id.
   */
  async createBrandPulseCampaign(payload: {
    ref_id: any; brand_name: string; brand_id: any; user_id: any; campaign_title?: string;
  }) {
    const path = `${BASE_URL}/brand-pulse/create-campaign-id`;
    try {
      const response = await http.postRequest(path, payload, null);
      return response;
    } catch (error) {
      throw new Error(`createBrandPulseCampaign :: ${error}`);
    }
  }

  /** Brand Pulse :: rename a tracking campaign (brand_campaigns.campaign_title). */
  async updateBrandPulseCampaignTitle(payload: { campaign_id: any; campaign_title: string }) {
    const path = `${BASE_URL}/brand-pulse/update-campaign-title`;
    try {
      const response = await http.postRequest(path, payload, null);
      return response;
    } catch (error) {
      throw new Error(`updateBrandPulseCampaignTitle :: ${error}`);
    }
  }

  async deleteBrandPulseCampaign(payload: { campaign_id: any }) {
    const path = `${BASE_URL}/brand-pulse/delete-campaign`;
    try {
      const response = await http.postRequest(path, payload, null);
      return response;
    } catch (error) {
      throw new Error(`deleteBrandPulseCampaign :: ${error}`);
    }
  }

  /** Brand Pulse :: flag the campaign's analytics for refresh (campaign_analytics.refresh_required = true). */
  async refreshBrandPulseCampaignAnalytics(payload: { campaign_id: any; user_id: any }) {
    const path = `${BASE_URL}/brand-pulse/refresh-campaign-analytics`;
    try {
      const response = await http.postRequest(path, payload, null);
      return response;
    } catch (error) {
      throw new Error(`refreshBrandPulseCampaignAnalytics :: ${error}`);
    }
  }

  async brandPulseRefreshStatus(payload: { campaign_id: any }) {
    const path = `${BASE_URL}/brand-pulse/refresh-status?campaign_id=${payload.campaign_id}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`brandPulseRefreshStatus :: ${error}`);
    }
  }

  async brandPulseAnalyticsSharePublicLink(payload: any) {
    const path = `${BASE_URL}/get/share-link/brand-pulse?campaign_id=${payload.campaign_id}&ref_id=${payload.ref_id}&username=${payload.username}`;
    try {
      const response = await http.postRequest(path, payload, null);
      return response;
    } catch (error) {
      console.error("Error in verifySharedUser:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`verifySharedUser :: ${error}`);
    }
  }

  // TODO: campaign id to be parsed
  // fb analytics 
  async fbAnalyticsMainDashboard(payload: any) {
    const path = `${BASE_URL}/fb/analytics/main-dashboard?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in fbAnalyticsMAinDashboard:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`fbAnalyticsMAinDashboard :: ${error}`);
    }
  }

  async fbAnalyticsInfluencerByType(payload: any) {
    const path = `${BASE_URL}/fb/analytics/influencer_by_type?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in fetchINfluencerByType:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`fetchINfluencerByType :: ${error}`);
    }
  }

  async fbAnalyticsLineChart(payload: any) {
    const path = `${BASE_URL}/fb/analytics/line-chart?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in fbAnalyticsLineChart:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`fbAnalyticsLineChart :: ${error}`);
    }
  }

  async fbAnalyticsSentiment(payload: any) {
    const path = `${BASE_URL}/fb/analytics/senntiment?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in fbAnalyticsSentiment:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`fbAnalyticsSentiment :: ${error}`);
    }
  }

  async fbAnalyticsPostLevelPerformance(payload: any) {
    const path = `${BASE_URL}/fb/analytics/post-level-performance?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&page=${payload.page}&limit=${payload.limit}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in fbAnalyticsPostLevelPerformance:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`fbAnalyticsPostLevelPerformance :: ${error}`);
    }
  }

  async fbAnalyticsTopPerformer(payload: any) {
    const path = `${BASE_URL}/fb/analytics/top-performer?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&type=${payload.type}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in fbAnalyticsTopPerformer:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`fbAnalyticsTopPerformer :: ${error}`);
    }
  }

  async fbAnalyticsTopPerformingHashtag(payload: any) {
    const path = `${BASE_URL}/fb/analytics/top-performing-hashtag?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&type=${payload.type}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in fbAnalyticsTopPerformingHashtag:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`fbAnalyticsTopPerformingHashtag :: ${error}`);
    }
  }
  // fb analytics 
  async igAnalyticsMainDashboard(payload: any) {
    const path = `${BASE_URL}/ig/analytics/main-dashboard?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in igAnalyticsMAinDashboard:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`igAnalyticsMAinDashboard :: ${error}`);
    }
  }
  async igAnalyticsGetInfluencerType(payload: any) {
    const path = `${BASE_URL}/ig/analytics/influencer-type?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in igAnalyticsInfluencerType:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`igAnalyticsInfluencerType :: ${error}`);
    }
  }

  // This function is not in use currently
  async igAnalyticsGetContentType(payload: any) {
    const path = `${BASE_URL}/ig/analytics/content-type?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in igAnalyticsInfluencerType:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`igAnalyticsInfluencerType :: ${error}`);
    }
  }
  async igAnalyticsGetGraphData(payload: any) {
    const path = `${BASE_URL}/ig/analytics/graph-data?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in igAnalyticsGetGraphData:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`igAnalyticsGetGraphData :: ${error}`);
    }
  }
  async igAnalyticsTopPerformance(payload: any) {
    const path = `${BASE_URL}/ig/analytics/top-performer?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&type=${payload.type}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in igAnalyticsInfluencerType:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`igAnalyticsInfluencerType :: ${error}`);
    }
  }
  async igAnalyticsPostLevelPerformance(payload: any) {
    const path = `${BASE_URL}/ig/analytics/post-level-performance?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&type=${payload.type}&page=${payload.page}&limit=${payload.limit}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in igAnalyticsInfluencerType:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`igAnalyticsInfluencerType :: ${error}`);
    }
  }
  async igAnalyticsTopPerformingHashtag(payload: any) {
    const path = `${BASE_URL}/ig/analytics/top-performing-hashtag?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&type=${payload.type}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in igAnalyticsTopPerformingHashtag:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`igAnalyticsTopPerformingHashtag :: ${error}`);
    }
  }
  async igAnalyticsSentiment(payload: any) {
    const path = `${BASE_URL}/ig/analytics/senntiment?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in igAnalyticsSentiment:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`igAnalyticsSentiment :: ${error}`);
    }
  }

  // yt analytics 
  async ytAnalyticsMainDashboard(payload: any) {
    const path = `${BASE_URL}/yt/analytics/main-dashboard?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in ytAnalyticsMAinDashboard:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`ytAnalyticsMAinDashboard :: ${error}`);
    }
  }

  async ytAnalyticsInfluencerByType(payload: any) {
    const path = `${BASE_URL}/yt/analytics/influencer_by_type?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in fetchINfluencerByType:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`fetchINfluencerByType :: ${error}`);
    }
  }

  async ytAnalyticsLineChart(payload: any) {
    const path = `${BASE_URL}/yt/analytics/line-chart?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in ytAnalyticsLineChart:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`ytAnalyticsLineChart :: ${error}`);
    }
  }

  async ytAnalyticsSentiment(payload: any) {
    const path = `${BASE_URL}/yt/analytics/senntiment?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in ytAnalyticsSentiment:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`ytAnalyticsSentiment :: ${error}`);
    }
  }

  async ytAnalyticsPostLevelPerformance(payload: any) {
    const path = `${BASE_URL}/yt/analytics/post-level-performance?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&page=${payload.page}&limit=${payload.limit}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in ytAnalyticsPostLevelPerformance:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`ytAnalyticsPostLevelPerformance :: ${error}`);
    }
  }

  async ytAnalyticsTopPerformer(payload: any) {
    const path = `${BASE_URL}/yt/analytics/top-performer?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&type=${payload.type}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in ytAnalyticsTopPerformer:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`ytAnalyticsTopPerformer :: ${error}`);
    }
  }

  async ytAnalyticsTopPerformingHashtag(payload: any) {
    const path = `${BASE_URL}/yt/analytics/top-performing-hashtag?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&type=${payload.type}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in ytAnalyticsTopPerformingHashtag:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`ytAnalyticsTopPerformingHashtag :: ${error}`);
    }
  }

  async ytAnalyticsDemography(payload: any) {
    const path = `${BASE_URL}/yt/analytics/demography?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in ytAnalyticsDemography:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`ytAnalyticsDemography :: ${error}`);
    }
  }
  async analyticsAddCost(payload: any) {
    const path = `${BASE_URL}/brand-pulse/add-cost`;
    try {
      const response = await http.postRequest(path, payload, null);
      return response;
    } catch (error) {
      console.error("Error in analyticsAddCost:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`analyticsAddCost :: ${error}`);
    }
  }

  /** Brand Pulse :: set the username of an Instagram post (campaign_analytics.username) and flag it for refresh. */
  async analyticsAddPostUsername(payload: { url_id: any; username: string }) {
    const path = `${BASE_URL}/brand-pulse/add-username`;
    try {
      const response = await http.postRequest(path, payload, null);
      return response;
    } catch (error) {
      console.error("Error in analyticsAddPostUsername:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`analyticsAddPostUsername :: ${error}`);
    }
  }

  /** Brand Pulse :: which of these url_ids already have a username saved in campaign_analytics. */
  async analyticsPostsWithUsername(payload: { url_ids: any[] }) {
    const path = `${BASE_URL}/brand-pulse/posts-with-username`;
    try {
      const response = await http.postRequest(path, payload, null);
      return response;
    } catch (error) {
      console.error("Error in analyticsPostsWithUsername:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`analyticsPostsWithUsername :: ${error}`);
    }
  }

  async analyticsGetManualViewsGrid(payload: any) {
    const path = `${BASE_URL}/analytics/views-grid?campaign_id=${payload.campaign_id}&user_id=${payload.user_id}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in analyticsGetManualViewsGrid:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`analyticsGetManualViewsGrid :: ${error}`);
    }
  }

  async analyticsSaveManualViewsBulk(payload: any) {
    const path = `${BASE_URL}/analytics/manual-views-bulk`;
    try {
      const response = await http.postRequest(path, payload, null);
      return response;
    } catch (error) {
      console.error("Error in analyticsSaveManualViewsBulk:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`analyticsSaveManualViewsBulk :: ${error}`);
    }
  }

  async analyticsDeletePost(payload: any) {
    const path = `${BASE_URL}/brand-pulse/delete-post`;
    try {
      const response = await http.postRequest(path, payload, null);
      return response;
    } catch (error) {
      console.error("Error in analyticsDeletePost:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`analyticsDeletePost :: ${error}`);
    }
  }

  async fbAnalyticsDemography(payload: any) {
    const path = `${BASE_URL}/fb/analytics/demography?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in fbAnalyticsDemography:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`fbAnalyticsDemography :: ${error}`);
    }
  }

  async igAnalyticsDemography(payload: any) {
    const path = `${BASE_URL}/ig/analytics/demography?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in igAnalyticsDemography:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`igAnalyticsDemography :: ${error}`);
    }
  }
  async analyticsAddPost(payload: any) {
    const path = `${BASE_URL}/brand-pulse/add-post`;
    try {
      const response = await http.postRequest(path, payload, null);
      return response;
    } catch (error) {
      console.error("Error in analyticsAddPost:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`analyticsAddPost :: ${error}`);
    }
  }


  // Brand Pulse :: bulk add posts from the Excel upload. payload: { campaign_id, posts: [{ post_url, platform, cost }] }
  async analyticsAddPostsBulk(payload: any) {
    const path = `${BASE_URL}/brand-pulse/add-posts-bulk`;
    try {
      const response = await http.postRequest(path, payload, null);
      return response;
    } catch (error) {
      console.error("Error in analyticsAddPostsBulk:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`analyticsAddPostsBulk :: ${error}`);
    }
  }

  async brandPulseProcessingUrls(payload: any) {
    const path = `${BASE_URL}/brand-pulse/processing-urls?campaign_id=${payload.campaign_id}&platform=${payload.platform}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in brandPulseProcessingUrls:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`brandPulseProcessingUrls :: ${error}`);
    }
  }

  // Campaign Tracking: where the default date range starts (earliest of first post / campaign created_at)
  async brandPulseCampaignDateRange(payload: any) {
    const path = `${BASE_URL}/brand-pulse/campaign-date-range?campaign_id=${payload.campaign_id}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in brandPulseCampaignDateRange:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`brandPulseCampaignDateRange :: ${error}`);
    }
  }

    async allPlatformAnalyticsMainDashboard(payload: any) {
    const path = `${BASE_URL}/all-platform/analytics/main-dashboard?campaign_id=${payload.campaign_id}&num_of_days=${payload.num_of_days}&page=${payload.page}&limit=${payload.limit}&share_access_key=${payload.share_access_key}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in allPlatformAnalyticsMainDashboard:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`allPlatformAnalyticsMainDashboard :: ${error}`);
    }
  }

}
